// extracted by mini-css-extract-plugin
export default {"myBtn":"MyButton_myBtn__2yioc","create":"MyButton_create__G--Qp","open":"MyButton_open__xMRyn","delete":"MyButton_delete__0+V2P"};